import React, { useState } from 'react';
import { useTenantBranding } from '@/context/TenantBranding';

// §tenant-branded intake §2: renders the tenant's logo when a tenant key
// resolved to one, else the default Fitpal logo. Drop-in replacement for the
// inline <img src="/fitpal-logo.png" …> headers across the forms — pass the same
// className so sizing is unchanged.
//
// §logo-render-PRD §4.2: onError → /fitpal-logo.png so a null/expired/403
// presigned tenant URL degrades to the Fitpal logo instead of a broken image.
// Loop-safe: once `errored`, src pins to the static default (which won't error).
const BrandLogo = ({ className, style, alt }) => {
  const { logoUrl, displayName } = useTenantBranding();
  const [errored, setErrored] = useState(false);
  const usingTenant = !!logoUrl && !errored;
  return (
    <img
      src={usingTenant ? logoUrl : '/fitpal-logo.png'}
      onError={() => setErrored(true)}
      alt={alt || (usingTenant ? (displayName || 'Logo') : 'FitPal')}
      className={className}
      style={style}
      data-testid="brand-logo"
    />
  );
};

export default BrandLogo;
